export const DAYS = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];
export const DEFAULT_GROUPS = [
  { id: "Weekdays", name: "", days: [0, 1, 2, 3, 4] },
  { id: "Weekend", name: "", days: [5, 6] },
];
export const localDateKey = (date) =>
  `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
export function parseLocalDate(key) {
  const [year, month, day] = key.split("-").map(Number);
  return new Date(year, month - 1, day, 12);
}
export function weekStart(date) {
  const monday = new Date(date);
  monday.setHours(12, 0, 0, 0);
  monday.setDate(monday.getDate() - ((monday.getDay() + 6) % 7));
  return localDateKey(monday);
}
export function weekDates(date) {
  const monday = parseLocalDate(weekStart(date));
  return DAYS.map((_, index) => {
    const day = new Date(monday);
    day.setDate(monday.getDate() + index);
    return localDateKey(day);
  });
}
export function monthDates(date) {
  const year = date.getFullYear(),
    month = date.getMonth();
  const count = new Date(year, month + 1, 0, 12).getDate();
  return Array.from(
    { length: count },
    (_, index) => new Date(year, month, index + 1, 12),
  );
}
export function planningProfile(prefs) {
  return validPlanningProfile(prefs?.planning)
    ? prefs.planning
    : { version: 1, mode: "groups", groups: DEFAULT_GROUPS };
}
export function validPlanningProfile(value) {
  if (
    !value ||
    value.version !== 1 ||
    !["daily", "groups", "weekly"].includes(value.mode) ||
    value.configured !== true
  )
    return false;
  if (
    !Array.isArray(value.groups) ||
    value.groups.length < 1 ||
    value.groups.length > 7
  )
    return false;
  const ids = new Set(),
    days = new Set();
  for (const group of value.groups) {
    if (
      !group ||
      typeof group.id !== "string" ||
      !/^[a-zA-Z][a-zA-Z0-9_-]{0,99}$/.test(group.id) ||
      ids.has(group.id) ||
      typeof group.name !== "string" ||
      group.name.length > 80 ||
      !Array.isArray(group.days) ||
      !group.days.length
    )
      return false;
    ids.add(group.id);
    for (const day of group.days) {
      if (!Number.isInteger(day) || day < 0 || day > 6 || days.has(day))
        return false;
      days.add(day);
    }
  }
  if (days.size !== 7 || (value.mode === "daily" && value.groups.length !== 1))
    return false;
  if (
    value.readyWeeks !== undefined &&
    (!Array.isArray(value.readyWeeks) ||
      value.readyWeeks.length > 1000 ||
      value.readyWeeks.some((key) => {
        if (typeof key !== "string" || !/^\d{4}-\d{2}-\d{2}$/.test(key))
          return true;
        const date = new Date(key + "T12:00:00Z");
        return (
          !Number.isFinite(date.getTime()) ||
          date.toISOString().slice(0, 10) !== key ||
          date.getUTCDay() !== 1
        );
      }))
  )
    return false;
  return true;
}
export function groupForDate(prefs, date) {
  const profile = planningProfile(prefs);
  if (profile.mode === "weekly") return "date:" + localDateKey(date);
  const day = (date.getDay() + 6) % 7;
  return (
    profile.groups.find((group) => group.days.includes(day))?.id || "Weekdays"
  );
}
export function plansForDate(values, date) {
  const key = localDateKey(date);
  const history = values.custom?.planHistory?.[key];
  if (history) return history;
  const profile = planningProfile(values.prefs);
  return profile.mode === "weekly"
    ? values.custom?.datedPlans?.[key] || []
    : values.templates?.[groupForDate(values.prefs, date)] || [];
}
export function reminderWeek(prefs, date) {
  const profile = planningProfile(prefs);
  if (profile.mode !== "weekly") return null;
  const target = new Date(date);
  if (target.getDay() === 0) target.setDate(target.getDate() + 1);
  const key = weekStart(target);
  return profile.readyWeeks?.includes(key) ? null : key;
}
